import config from 'styles/config'
import { backgroundColor, textSize, zIndex, titleFontSemiBold, color, boldFont } from 'styles/helpers'

const popinStyles = {
  overlay: {
    position: 'fixed',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    background: 'rgba(0, 0, 0, .25)',
    transitionDuration: '0',
    opacity: 0,
    pointerEvents: 'none'
  },
  isOpened: {
    ...zIndex('popin'),
    opacity: 1,
    backdropFilter: 'blur(3px)',
    pointerEvents: 'all'
  },
  isInitialized: {
    transitionDuration: '200ms',
  },
  dialog: {
    minHeight: 'calc(100% - (24px * 2))', // center small content
    margin: `${config.dimensions.boxMobileMargin}px 0`,
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: 'auto',
    justifyContent: 'center'
  },
  container: {
    pointerEvents: 'auto',
    width: '100%',
    position: 'relative',
    padding: config.dimensions.boxMobileMargin,
    ...backgroundColor('mainBackground'),
    boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.16)',
  },
  closeContainer: {
    position: 'absolute',
    right: 16,
    top: 16,
    display: 'block',
    ...textSize(22, 10),
    ...color('titleColor')
  },
  closeButton: {
    cursor: 'pointer'
  },
  title: {
    marginBottom: 7,
    ...textSize(16, 19),
    ...titleFontSemiBold()
  },
  text: {
    ...textSize(14, 19),
    '& p': {
      marginBottom: 16,
    },
    '& strong': {
      ...boldFont(),
    }
  },
  [config.mediaQueries.phonePortrait]: {
    closeContainer: {
      display: 'none'
    }
  },
  [config.mediaQueries.tabletPortrait]: {
    dialog: {
      width: 480,
      margin: `${config.dimensions.boxMargin}px auto`,
    },
    container: {
      padding: config.dimensions.boxMargin,
      borderRadius: 4,
    }
  }
}

export default popinStyles
